import { createEvent } from '@cobuildlab/react-simple-state';
import { ExperienceCategoryType } from '../../shared/types';

export const OnExperienceCategories = createEvent<ExperienceCategoryType[]>();
export const OnExperienceCategoriesError = createEvent();
